import React, { Component } from 'react'; // eslint-disable-line no-unused-vars
import { Card } from 'antd';
import { Link } from 'react-router-dom';

function PoetCard(props){
  return (
    <Card
      hoverable={true}
      className = "PoetCard">
      <Link
        to={"/poet/"+ props.poet.poetID}
        style={{ color: 'inherit' }}
        >
      <div className = "poet-card-flex">
        <img alt={props.poet.name} className = "poet-card-image" src={require('../../images/poets/' + props.poet.poetID  +'.png')} />
        <div>
          <h3>{props.poet.name}</h3>
          <p>{props.poet.shortBio}</p>
        </div>
      </div>
      </Link>
    </Card>
  )
}

export default PoetCard;



// WEBPACK FOOTER //
// ./src/components/Home/PoetCard.js